import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Send } from "lucide-react";

export default function AIChatPage() {
  const navigate = useNavigate();
  const [messages, setMessages] = useState([
    { role: "assistant", content: "Zdravo! Ja sam NAŠA AI Asistent. Postavi mi pitanje o NAŠA platformi, Tonini Bitlab ekosistemu ili MY.N.E.R. tehnologiji i rado ću pomoći." }
  ]);
  const [input, setInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [kbHeight, setKbHeight] = useState(0);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  useEffect(() => {
    document.body.classList.add("hide-tonini-fab");
    return () => document.body.classList.remove("hide-tonini-fab");
  }, []);

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const onResize = () => {
      const overlap = window.innerHeight - vv.height - vv.offsetTop;
      setKbHeight(overlap > 0 ? overlap : 0);
    };
    vv.addEventListener("resize", onResize);
    vv.addEventListener("scroll", onResize);
    onResize();
    return () => {
      vv.removeEventListener("resize", onResize);
      vv.removeEventListener("scroll", onResize);
    };
  }, []);

  useEffect(() => {
    // Sprecava iOS da pomera stranicu kada se tastatura otvori
    const fixScroll = () => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
    };
    window.addEventListener("resize", fixScroll);
    return () => window.removeEventListener("resize", fixScroll);
  }, []);

  const handleSend = async () => {
    if (!input.trim() || isLoading) return;
    const userMsg = { role: "user", content: input };
    const newMessages = [...messages, userMsg];
    setMessages(newMessages);
    setInput("");
    setIsLoading(true);
    try {
      const response = await fetch("/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ messages: newMessages })
      });
      const data = await response.json();
      if (response.ok) {
        setMessages([...newMessages, { role: "assistant", content: data.reply }]);
      } else {
        setMessages([...newMessages, { role: "assistant", content: "Došlo je do greške. Pokušaj ponovo." }]);
      }
    } catch {
      setMessages([...newMessages, { role: "assistant", content: "Greška pri slanju poruke." }]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      display: "flex", flexDirection: "column", height: "100svh",
      backgroundColor: "#000", fontFamily: '"JetBrains Mono", monospace', color: "#fff"
    }}>
      {/* Header */}
      <div style={{
        backgroundColor: "#111", borderBottom: "1px solid #22ff77",
        padding: "16px 20px", display: "flex", alignItems: "center",
        gap: "12px", flexShrink: 0
      }}>
        <button onClick={() => navigate(-1)} style={{
          background: "none", border: "none", color: "#22ff77",
          cursor: "pointer", display: "flex", alignItems: "center", gap: "6px",
          fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.2em"
        }}>
          <ArrowLeft size={16} /> Nazad
        </button>
        <span style={{ color: "#22ff77", fontWeight: "bold", fontSize: "15px", letterSpacing: "0.1em" }}>
          NAŠA AI Asistent
        </span>
      </div>

      {/* Poruke */}
      <div style={{
        flex: 1, overflowY: "auto", padding: "16px",
        paddingBottom: (kbHeight + 80) + "px",
        display: "flex", flexDirection: "column", gap: "12px"
      }}>
        {messages.map((m, idx) => (
          <div key={idx} style={{
            alignSelf: m.role === "user" ? "flex-end" : "flex-start",
            backgroundColor: m.role === "user" ? "#1a1a1a" : "#0a0a0a",
            border: `1px solid ${m.role === "user" ? "#ff7a18" : "#22ff77"}`,
            color: "#fff", padding: "12px 16px", borderRadius: "8px",
            maxWidth: "85%", fontSize: "14px", lineHeight: "1.6", whiteSpace: "pre-wrap"
          }}>
            {m.content}
          </div>
        ))}
        {isLoading && (
          <div style={{ color: "#22ff77", fontSize: "12px", fontStyle: "italic" }}>
            AI kuca odgovor...
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>

      {/* Input */}
      <div style={{
        position: "fixed", bottom: kbHeight, left: 0, right: 0,
        borderTop: "1px solid #22ff77", padding: "12px 16px",
        transition: "bottom 0.15s ease",
        display: "flex", gap: "10px", backgroundColor: "#111", flexShrink: 0
      }}>
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
          placeholder="Pitaj me nešto..."
          style={{
            flex: 1, backgroundColor: "#000", color: "#22ff77",
            border: "1px solid #22ff77", borderRadius: "5px",
            padding: "12px", outline: "none",
            fontFamily: '"JetBrains Mono", monospace', fontSize: "16px"
          }}
        />
        <button onClick={handleSend} disabled={isLoading} style={{
          backgroundColor: "#ff7a18", color: "#000", border: "none",
          borderRadius: "5px", padding: "0 18px", cursor: "pointer",
          fontWeight: "bold", fontSize: "18px", display: "flex",
          alignItems: "center", justifyContent: "center"
        }}>
          <Send size={18} />
        </button>
      </div>
    </div>
  );
}
